import { Badge } from "@mantine/core";
import { StainMarkerVerificationStatus } from "../../../services/admin/stains.service";

interface Props {
  status: StainMarkerVerificationStatus;
}

const STATUS_COLORS: Record<StainMarkerVerificationStatus, string> = {
  pending: "gray",
  sent: "blue",
  accepted: "green",
  rejected: "orange",
  failed: "red",
  timed_out: "red",
  dry_run: "blue",
};

export default function StainMarkerVerificationStatusBadge({ status }: Props) {
  return (
    <Badge color={STATUS_COLORS[status]} variant="light" size="sm">
      {status.replace("_", " ")}
    </Badge>
  );
}
